import { useApi } from './use-api-call';
import { UserDTO } from './user-api';


export const useSearchAccessTeamApi = () => useApi<{ 
accessTeams: AccessTeamDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/access-team/search-access-team');

export const useGetAccessTeamApi = () => useApi<{ accessTeam: AccessTeamDTO; allowEdit: boolean; }>('/access-team/get-access-team/{serial}');

export const useSaveAccessTeamApi = () => useApi<{ accessTeam: AccessTeamDTO}>('/access-team/save-access-team');

export const useDeleteAccessTeamApi = () => useApi('/access-team/delete-access-team/{serial}');

export interface AccessTeamDTO { 
serial?:number;
title:string;
description:string;
isActive:boolean;
createdAt?:Date;
createdBy?:string;
}
